const dataFaq = [
    {
        title: '¿A qué hora es el check-in y el check-out?',
        text: 'El horario de check-in es a partir de las 14:00 hs y el check-out es hasta las 11:00 hs. Si llegas antes o te vas más tarde, puedes dejar tu equipaje en nuestra guarda equipaje de forma segura.',
        show: 'true'
    },
    {
        title: '¿El desayuno está incluido en la tarifa?',
        text: 'Sí, ofrecemos un desayuno completo y variado incluido en tu estadía para que comiences el día con energía.',

    },
    {
        title: '¿Tienen habitaciones privadas y compartidas?',
        text: 'Contamos con ambas opciones. Puedes elegir entre habitaciones compartidas ideales para conocer a otros viajeros, o habitaciones privadas si prefieres mayor tranquilidad y privacidad.'
    },
    {
        title: '¿El hostel cuenta con conexión Wi-Fi gratuita?',
        text: 'Sí, ofrecemos Wi-Fi gratuito de alta velocidad en todas las habitaciones y áreas comunes del hostel.'
    },
    {
        title: '¿Hay cocina disponible para los huéspedes?',
        text: 'Sí, contamos con una amplia cocina totalmente equipada de uso compartido para que puedas preparar tus propias comidas en cualquier momento del día.'
    },
    {
        title: '¿Ofrecen servicio de lavandería?',
        text: 'Sí, contamos con servicio de lavandería por un costo adicional para que puedas lavar y secar tu ropa cómodamente durante tu viaje.'
    },
]

export default dataFaq;